export const experience = [
   {
    id: 3,
    role: "Software Engineer",
    company: "Starbucks Coffee Company (September 2026 - Present)",
    description: "",
  },
  {
    id: 3,
    role: "Full-stack Engineer",
    company: "7th Dimension Studios (September 2025 - March 2026)",
    description: "Built a fullstack web application using React, Node.js, Express.js, and MySQL, with secure user authentication implemented via JWT tokens and REST APIs. Followed an iterative SDLC process and used GitLab for version control and CI/CD pipeline management.",
  },
  {
    id: 2,
    role: "Peer Facilitator (TA) / STEM Course Grader",
    company: "University of Washington Bothell (Mar 2025 - Mar 2026)",
    description: "Served as a Teaching Assistant for Capstone (CSS 497), Data Structures and Algorithms I (C++), and Object-Oriented Programming (Java). Reviewed and graded assignments, projects, and exams, provided consulting and supporting materials to help students meet learning objectives, and held 10+ hours of weekly office hours supporting 30+ students with debugging, performance optimization, and tutoring",
  },
  {
    id: 1,
    role: "Fellow/ Camp Counselor",
    company: "Girls Make Games (May 2022 - July 2025)",
    description: "Worked hands-on with campers to teach game production and project management, using Construct 3 and Kanban boards for game design and development. Met deadlines efficiently and accurately, and kept management updated through clear technical writing.",
  },
];